import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageMedia } from '@madeinlune/drupal-types';
import { MediaImageComponent } from '@nx-massaud/media/ui/image';
import { SvgIconComponent } from '@nx-massaud/ui/svg-icon';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, take } from 'rxjs';
import { LetDirective, PushPipe } from '@ngrx/component';
import { NgMathPipesModule } from 'ngx-pipes';
import { MediaPressKit } from '@madeinlune/massaud-types';

export interface UIPressKit {
  id: string | undefined;
  title: string | undefined;
  url: string | undefined;
  thumb: ImageMedia | undefined;
  fileName: string | undefined;
  weight: number | undefined;
}

@Component({
  selector: 'msd-ui-renderer-press-kit',
  standalone: true,
  imports: [
    CommonModule,
    MediaImageComponent,
    SvgIconComponent,
    PushPipe,
    LetDirective,
    NgMathPipesModule,
  ],
  template: `
    <ng-container *ngIf="pressKit">
      <i2l-media-image [image]="pressKit.thumb"></i2l-media-image>
      <div class="b-footer">
        <h3 [innerHTML]="pressKit.name"></h3>
        <ng-container *ngIf="pressKit.file?.weight as weight">
          <small [innerHTML]="weight | bytes : 2"></small>
        </ng-container>
        <ng-container *ngIf="pressKit.file?.url as url">
          <ng-container *ngrxLet="downloading$; let downloading">
            <button
              class="msd-btn icon"
              (click)="onDownload()"
              [class.animate-downloading]="downloading"
              [class.downloading]="downloading"
            >
              <msd-ui-svg-icon
                [icon]="downloading ? 'downloading' : 'download'"
              ></msd-ui-svg-icon>
            </button>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  `,
  styleUrls: ['./renderer-press-kit.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class RendererPressKitComponent {
  @Input() pressKit: MediaPressKit | undefined;

  downloading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private httpClient: HttpClient) {}

  onDownload() {
    const url = this.pressKit?.file?.url;
    const fileName = this.pressKit?.file?.filename;
    if (url && fileName) {
      this.downloading$.next(true);
      this.httpClient
        .get(
          `https://master-7rqtwti-lofgzy3ea3siu.eu-5.platformsh.site${url}`,
          { responseType: 'blob' }
        )
        .pipe(take(1))
        .subscribe((result) => {
          const aElement = document.createElement('a');
          aElement.setAttribute('download', fileName);
          const href = URL.createObjectURL(result);
          aElement.href = href;
          aElement.setAttribute('target', '_blank');
          aElement.click();
          URL.revokeObjectURL(href);
          this.downloading$.next(false);
        });
    }
  }
}
